import { useSelector } from "react-redux";
import { useMemo } from "react";

const useLocaleCodes = () => {
  const locales = useSelector((state) => state?.siteConfigurationReducer?.locales);

  return useMemo(() => {
    return locales ? locales.map((locale) => locale.code) : [];
  }, [locales]);
};

export default useLocaleCodes;
